import React, { Fragment } from "react";
import img13 from "../../images/service/nft-marketplce Hero.png";
//import ServiceFaq from "../SeviceSinglePage/ServiceFaq";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import GallerySection from "../SeviceSinglePage/GallerySection";
import BrandSection from "../../components/FeatureSection/BrandSection";

import feature1 from "../../images/icon/feature-icon01.svg";
import feature2 from "../../images/icon/feature-icon02.svg";
import feature3 from "../../images/icon/feature-icon03.svg";
import feature4 from "../../images/icon/blog-icon01.svg";
/*
  Content for this page taken from referenced data provided by user.
  Source references: :contentReference[oaicite:2]{index=2} :contentReference[oaicite:3]{index=3}
*/



  const features = [
    {
      icon: feature1,
      title: "Formulate a dynamic organizational strategy",
      content: "Build a robust NFT-driven foundation that aligns with futuristic tech innovation.",
    },
    {
      icon: feature2,
      title: "Develop your own NFT marketplace",
      content: "Launch a custom NFT marketplace designed entirely around your business goals.",
    },
    {
      icon: feature3,
      title: "Create a customized NFT platform",
      content: "Craft fully tailored NFT platforms that support scalability, creativity, and growth.",
    },
    {
      icon: feature4,
      title: "Leverage powerful NFT tools",
      content: "Use advanced NFT technologies to gain a competitive advantage in the market.",
    },
  ];

const nftServices = [
  {
    title: "NFT Marketplace Consultation",
    content:
      "Our experts collaborate closely with you to define goals, validate ideas and map technical requirements. We study NFT ecosystems, assess legal considerations, compare platforms and finalize the ideal blockchain, tools and integrations needed for a successful launch.",
  },
  {
    title: "NFT Marketplace Development",
    content:
      "We begin by crafting an MVP, then expand features iteratively. Our team configures the blockchain, develops reliable contracts and builds trading modules used to mint, list, manage and exchange NFTs securely on your marketplace.",
  },
  {
    title: "Multi-Chain NFT Marketplace Development",
    content:
      "Create a cross-chain ecosystem that lets NFTs move fluidly between networks while supporting large-scale participation. This enables cheaper transactions, shared liquidity, fractional assets, curated collections and immersive user experiences.",
  },
  {
    title: "NFT Mobile & Web App Development",
    content:
      "We build sleek, responsive web interfaces and mobile apps across iOS and Android, enabling users to mint, browse, purchase and manage NFTs anytime with smooth, intuitive and performance-focused app experiences.",
  },
  {
    title: "NFT Smart Contract Development",
    content:
      "We create smart contracts handling minting logic, royalty payouts, metadata rules and trade flows—engineered for security, optimized for gas usage and thoroughly audited before going live on supported networks.",
  },
  {
    title: "NFT Integrations & Tools",
    content:
      "Connect your project with wallets, NFT markets and essential APIs, while offering creators dashboards, analytics, royalty tools, asset controls and additional utilities to enhance their workflow and engagement.",
  },
];


const NftMarketplaceService: React.FC = () => {


  const highlights = [
    "Formulate a dynamic organizational strategy based on NFT technologies",
    "Develop your own NFT marketplace based solely on your likings",
    "Create a customized NFT platform",
    "Leverage powerful NFT tools and technologies to gain a competitive edge",
  ];

  return (
    <Fragment>
      <div className="about-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle="NFT Marketplace" pagesub="Service details" />

            <section className="service-details pos-rel">
              <div className="container">
                {/* ========= HERO IMAGE + VIDEO CTA ========= */}
                <div className="single-item-image service-det-img mb-75">
                  <img src={img13} alt="simage" />
                </div>

                {/* ========= TITLE & INTRO ========= */}
                <h2 className="details-content-title mb-15">
                  The Best Blockchain Development Agency and Your Web 3.0 partner
                </h2>

                <p>
                  Want to create an NFT marketplace? You have come to the right place. We provide the best NFT marketplace development services in the crypto space and ensure to upgrade your business to great heights and enable instant business traction.
                </p>

                <div className="row mt-30 mb-30">
                  <div className="col-md-6">
                    <ul className="iconlist_block">
                      <li><span className="iconlist_text">4+ Years Experience in Blockchain</span></li>
                      <li><span className="iconlist_text">500+ Employees</span></li>
                      <li><span className="iconlist_text">200+ Projects</span></li>
                      <li><span className="iconlist_text">150+ Blockchain Experts</span></li>
                    </ul>
                  </div>

                  <div className="col-md-6">
                    <p>
                      Comcodes Techwork is a top-level, dedicated blockchain and non-fungible token development business that offers cutting-edge development and marketing services for a diverse range of blockchain applications. Our team is exceptionally specialized in the NFT niche. With our professional help and services, your company will be able to:
                    </p>

                    <ul className="iconlist_block mt-20">
                      {highlights.map((h, i) => (
                        <li key={i}><span className="iconlist_text">{h}</span></li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* ========= CONSULTATION + DEVELOPMENT DESCRIPTION ========= */}
                <h3 className="item_details_info_heading mb-20 mt-20">
                  NFT Marketplace Consultation
                </h3>

                <p className="mb-30">
                  Our consultation team will sit with you for absorbing the requirements. We’ll then conduct feasibility studies and finally document the feasible requirements. Before delving into the NFT marketplace development process, we will research the NFT market as well as your competitors to move further. Our analyst team will examine the regulatory risks involved. Next, we’ll take off to the core steps like deciding on the tech stack, architecture, and digital wallets to be integrated into the platform.
                </p>

                <h3 className="item_details_info_heading mb-20 mt-20">
                  NFT Marketplace Development
                </h3>

                <p className="mb-40">
                  It is a feasible idea to start with the MVP (Minimum Viable Product) and unfurl the other development steps further. You can decide on the blockchain tech to be used and we’ll set up that blockchain. Next, we’ll develop smart contracts to determine the marketplace’s functionality. Then, the features of the platform will be incorporated.
                </p>

                <h3 className="item_details_info_heading mb-20 mt-20">
                  Create a spectacular NFT trading platform
                </h3>

                <p className="mb-40">
                  Our professional services and dedication to quality NFT development will enable you to create a spectacular NFT trading platform. By using our services for developing NFT, you can create a specular NFT trading platform. We encourage you to build your business using our pre-engineered solutions to enter the competitive NFT industry. Your vibrant NFT marketplace will attract merchants who may wish to showcase rare NFTs and attract buyers.
                </p>

                {/* ========= FEATURE GRID (cards) ========= */}
<section className="service pos-rel bg_img">
  <h2 className="details-content-title mt-30 mb-30">
    NFT Marketplace Development Services
  </h2>

  <div className="container">
    <div className="row mt-none-30">
      {nftServices.map((svc, idx) => (
        <div className="col-lg-6 mt-30" key={idx}>
          
          {/* CARD */}
          <div
            className="xb-ser-item xb-border"
            style={{
              height: "260px",                // fixed height (perfectly even)
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between", // pushes description to bottom
              padding: "25px 25px",
              transition: "all 0.3s ease",
              transform: "translateY(0)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-10px)";
              e.currentTarget.style.boxShadow =
                "0px 10px 30px rgba(0,0,0,0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >

            {/* TITLE - always at the top */}
            <h3
              className="xb-item--title border-effect"
              style={{
                marginBottom: "15px",
                fontSize: "20px",
                minHeight: "50px", // prevents title height differences from breaking the card box
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              {svc.title}
            </h3>

            {/* DESCRIPTION - always at the bottom */}
            <p
              className="xb-item--content"
              style={{
                marginTop: "auto",      // pushes it down
                fontSize: "15px",
                lineHeight: "1.5",
                color: "#ddd",
                overflow: "hidden",      // prevents breaking
                textOverflow: "ellipsis",
              }}
            >
              {svc.content}
            </p>

          </div>
        </div>
      ))}
    </div>
  </div>
</section>


                <BrandSection />

                <section className="hero pos-rel bg_img" style={{ padding: "30px 0" }}>
  <div className="container">

    {/* ----------- Heading ----------- */}
    <h2 className="details-content-title title text-center wow fadeInUp" data-wow-delay="100ms">
      Highlights That Emphasize Our NFT Platform
    </h2>

    {/* ----------- Sub Heading ----------- */}
    <p
      className="sub-title text-center wow fadeInUp"
      data-wow-delay="200ms"
      style={{ maxWidth: "900px", margin: "20px auto 50px" }}
    >
      Comcodes Techwork is a top-level, dedicated blockchain and non-fungible token development business that offers cutting-edge development and marketing services for a diverse range of blockchain applications.
    </p>

    {/* ----------- Feature Cards ----------- */}
    <div className="row mt-30">
      {features.map((f, i) => (
        <div className="col-lg-3 col-md-6 mt-30" key={i}>
          <div
            className="xb-feature-item wow fadeInUp"
            data-wow-delay={`${300 + i * 100}ms`}
            data-wow-duration="600ms"
            style={{ height: "100%" }}
          >
            <div
              className="xb-item--inner xb-border"
              style={{
                padding: "35px 25px",
                textAlign: "center",
                minHeight: "320px",       // ⭐ makes all cards equal height
                height: "100%",
                display: "flex",          // ⭐ ensures layout consistency
                flexDirection: "column",
              }}
            >
              {/* Icon */}
              <span
                className="xb-item--icon"
                style={{ marginBottom: "15px", display: "inline-block" }}
              >
                <img src={f.icon} alt="icon" style={{ width: "80px" }} />
              </span>

              {/* Title */}
              <h3
                className="xb-item--title"
                style={{ marginBottom: "15px", minHeight: "55px" }} // ⭐ equal spacing
              >
                {f.title}
              </h3>

              {/* Description */}
              <p
                className="xb-item--content"
                style={{ lineHeight: "1.6", marginTop: "auto" }} // ⭐ pushes text to bottom evenly
              >
                {f.content}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>

  </div>
</section>


                {/* ========= GALLERY (if applicable) ========= */}
                <GallerySection />

              </div>

              
                
            </section>
          </main>

          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default NftMarketplaceService;
